<template>
    <div class="cart-promocode gray-block">
        <template v-if="!promoCodeApplied">
            <div class="cart-promo-code-form">
                <h4 class="cart-promocode-title">Есть промокод?</h4>
                <q-input outlined
                         dense
                         v-model="promoCodeForm.promo_code"
                         label="Введите промокод"
                         :error-message="promoCodeForm.errors.get('promo_code')"
                         :error="promoCodeForm.errors.has('promo_code')"
                         @keydown="promoCodeForm.errors.clear('promo_code')">
                    <template v-slot:after>
                        <q-btn outline label="Применить" @click.prevent="applyPromoCode"/>
                    </template>
                </q-input>
            </div>
        </template>
        <template v-else>
            <div class="cart-promo-code-applied">
                <span class="q-pr-md" v-html="'Промокод <span class=\'text-weight-bold\'>' + promoCodeForm.promo_code + '</span> применён!'"></span>
                <q-btn color="primary" label="Удалить" @click.prevent="removePromoCode"/>
            </div>
        </template>
    </div>
</template>

<script>
import promoCode from "../../mixins/promo_code";

export default {
    name: 'CartPromoCode',
    props: {
        code: {
            type: String,
            required: false,
            default: '',
        }
    },
    mixins: [
        promoCode
    ],
}
</script>
